import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/home/home'
import { useEffect } from 'react';
import ReactGA from 'react-ga4';


ReactGA.initialize('G-QNCG49T610'); 

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
        </Routes>
    );
}

function AppWrapper() {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }, [location]);

    return <App />;
}

export default function MainApp() {
    return (
        <Router>
            <AppWrapper />
        </Router>
    );
}